<template>
  <div>
    <v-row justify="space-between" class="header-container">
      <v-col md="6" :cols="12" class="pa-0">
        <div class="checkname-header">Name Check</div></v-col
      >
      <v-col md="6" :cols="12" class="pa-0">
        <div class="tab-header-text text-right">
          <v-btn
            @click="initialize"
            class="pl-5 pr-5 xs-full-width font-weight-light btn-refresh"
            elevation="0"
            color="#d9d9d9"
            outlined
          >
            <v-icon left>mdi-cached</v-icon>
            <span class="text-refresh">{{
              $vuetify.lang.t('$vuetify.courseManagement.filterBar.refresh')
            }}</span>
          </v-btn>

          <v-btn
            @click="confirmDialog = true"
            elevation="0"
            class="pl-5 pr-5 xs-full-width font-weight-light button-primary white--text"
          >
            <v-icon left>mdi-plus</v-icon>
            New Check
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <div v-if="listCheckName == null || listCheckName.length == 0">
      <v-row class="ma-0" align="center" justify="center">
        <v-icon class="mx-auto" color="#E1E2E6" size="200px">mdi-account-check</v-icon>
      </v-row>
      <v-row class="ma-0" align="center" justify="center">
        <div class="font-weight-bold no-data">ไม่มีรายการให้แสดง</div>
      </v-row>
    </div>
    <div
      v-else
      v-for="(checkname, index) in listCheckName"
      :key="checkname._id"
      class="checkname-container"
    >
      <div class="checkname-icon">
        <v-icon
          :color="
            checkname.count == checkname.participant ? '#34b576' : 'rgba(0, 0, 0, 0.25)'
          "
          >mdi-check</v-icon
        >
      </div>
      <div class="checkname-action">
        <!-- <v-icon>mdi-dots-horizontal</v-icon> -->

        <v-row class="ma-0 justify-content-center">
          <div v-if="checkname.count > 0" :class="checkname.count == checkname.participant ? 'checkname-total full': 'checkname-total'">
            {{ checkname.count }} / {{ checkname.participant }}</div
          >
          <div v-else class="checkname-total zero">{{ checkname.count }}</div
          >
        </v-row>
        <v-row class="ma-0 justify-content-center">
          <v-btn class="mr-10 checkname-feedback" text @click="showCheckedStudentNameDialog(index)">ดูรายชื่อผู้ตอบกลับ</v-btn>
          <!-- <span class="checkname-feedback"> การตอบกลับ </span> -->
        </v-row>
      </div>
      <div class="checkname-detail">
        <v-row class="ma-0">
          <span class="checkname-name">
            เช็คชื่อครั้งที่ {{ checkname.term }}</span
          >
        </v-row>
        <v-row class="ma-0">
          <span class="checkname-link">
            เมื่อเวลา {{ checkname.created_at | moment('HH:mm:ss') }} น.</span
          >
        </v-row>
      </div>
    </div>

    <v-pagination
      v-if="listCheckName != null && listCheckName.length > 0"
      v-model="currentPage"
      class="pagination-align-right justify-flex-end"
      :length="totalCheckName"
    ></v-pagination>

    <v-dialog v-model="confirmDialog" max-width="450">
      <v-card>
        <v-card-title class="headline">เวลาในการเช็คชื่อ</v-card-title>

        <v-card-text class="pb-0">
          <v-row>
            <v-col>
              <p class="subtitle-1">
                เมื่อกดยืนยันแล้ว
                ผู้ชมถ่ายทอดสดจะสามารถเช็คชื่อได้ในเวลาที่กำหนดเท่านั้น
              </p>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col class="d-flex pa-0" cols="6">
              <v-text-field
                hide-details
                class="mx-3"
                type="number"
                v-model="mins"
                min="0"
                @change="checkMinMins"
                single-line
                outlined
              ></v-text-field>
              <!-- <v-spacer></v-spacer> -->
              <p class="subtitle-1 pt-3">นาที</p>
            </v-col>
            <v-col class="d-flex pa-0" cols="6">
              <v-text-field
                hide-details
                class="mx-3"
                type="number"
                v-model="secs"
                min="0"
                max="59"
                @change="checkMinSecs"
                single-line
                outlined
              ></v-text-field>
              <!-- <v-spacer></v-spacer> -->
              <p class="subtitle-1 pt-3">วินาที</p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider class="mt-3"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            class="title"
            color="grey darken-1"
            large
            outlined
            @click="confirmDialog = false"
            >ยกเลิก</v-btn
          >

          <v-btn
            class="title"
            color="primary darken-1"
            large
            dark
            @click="requestCheckStudent"
            :loading="loadingBtn"
            >ยืนยัน</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="checkedStudentNameDialog" max-width="450">
      <v-card>
        <v-card-title class="headline">
          รายงานการเช็คชื่อ
        </v-card-title>
        <v-card-text>
          <div>
            <v-row>
              <v-col class="font-weight-bold">
                ชื่อ-สกุล
              </v-col>
              <v-spacer></v-spacer>
              <v-col  class="font-weight-bold" align="right ">
                สถานะ
              </v-col>
            </v-row>

            <v-divider></v-divider>
          <div v-for="(student, index) in participantList" v-bind:key="index">
            <v-row class="pa-0">
              <v-col>
                {{ student.student.firstName }}
                {{ student.student.lastName }} <br>
                ({{ student.student.email }})
              </v-col>
              <v-spacer></v-spacer>
              <v-col align="right">
                <div v-if="studentInCheckedList(student.student._id)" class="green--text">
                  เช็คชื่อแล้ว<br>
                </div>
                <div v-else class="red--text">
                  ยังไม่ได้เช็คชื่อ
                </div>
              </v-col>
            </v-row>
            <v-divider></v-divider>
          </div>

          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="checkedStudentNameDialog=false">
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {
  getCheckStudentList,
  requestCheckStudent,
} from '@/service/course/livev2';
import $ from 'jquery';
export default {
  props: {
    liveId: {
      type: String,
    },
  },
  name: 'checkName',
  data: () => ({
    // views
    confirmDialog: false,
    checkedStudentNameDialog: false,

    // params
    // liveStreamID: "5ebd1312fa34d74e7c11344e",
    // delay: 10000,
    mins: 0,
    secs: 0,

    // data
    checkStudentList: [],
    participantList: [],
    checkedStudentIdList: [],
    sizePerPage: 5,
    currentPage: 1,
    participant: 1, // checkthis

    loadingBtn: false
  }),
  computed: {
    listCheckName() {
      const start = (this.currentPage - 1) * this.sizePerPage,
        end = start + this.sizePerPage;
      let data = this.checkStudentList;
      return data.slice(start, end);
    },
    totalCheckName() {
      let l = this.checkStudentList.length,
        s = this.sizePerPage;
      return Math.ceil(l / s);
    },
  },
  async mounted() {
    await this.initialize();
  },
  methods: {
    async initialize() {
      this.mins = 0;
      this.secs = 30;
      await this.getCheckStudentList();
    },
    showCheckedStudentNameDialog(index) {
      console.log(index)
      this.checkedStudentNameDialog = true
      this.checkedStudentIdList = []
      for (let i=0;i<this.checkStudentList[index].checked_student_list.length; i++){
        this.checkedStudentIdList.push(this.checkStudentList[index].checked_student_list[i].student._id)
      }
    },
    studentInCheckedList(studentId){
      return this.checkedStudentIdList.includes(studentId)
    },
    checkMinMins() {
      if (this.mins < 0) {
        this.mins = 0;
      } else if (this.mins >= 60) {
        this.mins = 59;
      }
      this.mins = Math.floor(this.mins);
    },
    checkMinSecs() {
      if (this.secs < 0) {
        this.secs = 0;
      } else if (this.secs >= 60) {
        this.secs = 59;
      }
      this.secs = Math.floor(this.secs);
    },
    async requestCheckStudent() {
      this.loadingBtn = true
      let params = {
        delay: this.mins * 60 * 1000 + this.secs * 1000,
      };
      this.confirmDialog = false;

      await requestCheckStudent(this.liveId, params);
      this.loadingBtn = false
      await this.initialize();
    },
    timeToString(time) {
      var date = new Date(time);
      var hours = date.getHours();
      var minutes = '0' + date.getMinutes();

      return hours + ':' + minutes.substr(-2) + ' น.';
    },
    timeToStringSecond(time) {
      var date = new Date(time);
      var hours = date.getHours();
      var minutes = '0' + date.getMinutes();
      var seconds = '0' + date.getSeconds();

      return hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2) + ' น.';
    },
    async getCheckStudentList() {
      let result = await getCheckStudentList(this.liveId);
      console.log(result)
      this.checkStudentList = result.name_check_list
      this.participantList = result.participant_list
      // setTimeout(function() {
      //   $("#containerCheckName").scrollTop($("#containerCheckName")[0].scrollHeight);
      // }, 100);
    },
  },
};
</script>
<style lang="scss" scoped>
.txtHead {
  color: #00527b;
}
.btnNewCheck {
  background-color: #50adde !important;
  border-radius: 0px;
  width: 100%;
  text-transform: unset;
}
.btnReload {
  background-color: #eae9e9 !important;
  border-radius: 0px;
  width: 100%;
  text-transform: unset;
}
.message-container {
  position: relative;
  // padding: 12px;
  height: 88vh;
}
.message-scroll {
  height: 87vh;
  overflow: hidden;
}
.message-detail {
  /* background-color: ghostwhite; */
  height: 80%;
  /* margin-bottom: 10px; */
  overflow-y: scroll;
  /* overflow: hidden; */
}
.message-detail:hover {
  /* background-color: ghostwhite; */
  /* height: 470px; */
  /* margin-bottom: 10px; */
  /* overflow-y: scroll; */
  /* overflow: hidden; */
}
.chat-avatar {
  padding: 10px;
  width: 50px;
  display: inline-table;
}
.chat-message {
  padding: 10px;
  display: inline-table;
  font-size: 16px;
  /* width: 50px; */
}
.chat-name {
  font-weight: bold;
}
.chat-time {
  font-weight: bold;
  padding: 10px;
  width: 80px;
  float: right;
}
.owner-message {
  color: white;
}
/* .send-message-container{

} */
// .send-message-container {
//   /* position: relative; */
//   /* height: 200px; */
//   /* border: 3px solid red; */
//   /* position: absolute; */
//   /* width: 100%; */
//   /* bottom: 10px; */
//   position: absolute;
//   bottom: 10px;
//   width: 92%;
// }

.send-message-input {
  /* position: absolute;
  bottom: 10px; */
  /* border: 3px solid #8AC007; */
  display: inline-block;
}
.send-message-btn {
  float: right;
  /* display: inline-block; */
  width: 90px;
}
.message-box {
  padding-left: 15px;
  padding-right: 15px;
  // margin-bottom: 15px;
}
.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
  border-radius: 8px;
}
.send-container {
  padding-left: 10px;
  padding-right: 10px;
}
</style>

<style lang="scss" scoped>
.checkname-header {
  font-size: 26px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
}
.checkname-name {
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
  margin-bottom: 6px;
}
.checkname-total {
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
  margin-bottom: 6px;
  justify-content: center;
  &.full {
    color: #34b576;
  }
  &.zero {
    color: #9b9b9b;
  }
}
.checkname-link {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #9b9b9b;
}
.checkname-feedback {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #9b9b9b;
  justify-content: center;
}
.checkname-container {
  border-radius: 4px;
  background-color: #f7f7f7;
  padding: 20px;
  margin-bottom: 10px;
  width: 100%;
}
.header-container {
  margin: 0px;
  margin-bottom: 30px;
}
.checkname-icon {
  float: left;
  width: 40px;
  margin-top: 8px;
}
.checkname-action {
  float: right;
  width: 85px;
  align-self: center;
}
.checkname-detail {
  margin: 0 auto;
  // width: calc(100% - 85px - 37px);
  line-break: anywhere;
}
.pagination-align-right {
  justify-content: flex-end;
  padding-top: 15px;
}
.btn-refresh {
  margin-right: 30px;
}
.text-refresh {
  color: rgba(0, 0, 0, 0.65);
}
@media only screen and (min-width: 769px) and (max-width: 1024px) {
  .btn-refresh {
    margin-right: 0px;
  }
}
.justify-content-center{
  justify-content: center;
}
.no-data {
  color: #e1e2e6;
}
</style>

<style lang="scss">
.pagination-align-right {
  .v-pagination__item--active {
    background-color: #308ab7 !important;
    border-color: #308ab7 !important;
  }
}
.pagination-align-right.justify-flex-end {
  .v-pagination.theme--light {
    justify-content: flex-end;
  }
}
</style>